import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/direct-messages`;
const LOGS_API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/email-logs`;

export const dmApi = {
  list: (exhibitionId) => axios.get(`${API}?exhibition_id=${exhibitionId}`).then((r) => r.data),
  create: (payload) => axios.post(API, payload).then((r) => r.data),
  get: (id) => axios.get(`${API}/${id}`).then((r) => r.data),
  update: (id, payload) => axios.patch(`${API}/${id}`, payload).then((r) => r.data),
  archive: (id) => axios.delete(`${API}/${id}`).then((r) => r.data),
  preview: (id) => axios.post(`${API}/${id}/preview`).then((r) => r.data),
  testSend: (id, to) => axios.post(`${API}/${id}/test-send`, { to }).then((r) => r.data),
  schedule: (id, scheduledFor) => axios.post(`${API}/${id}/schedule`, { scheduled_for: scheduledFor }).then((r) => r.data),
  sendNow: (id) => axios.post(`${API}/${id}/send-now`).then((r) => r.data),
  reset: (id) => axios.post(`${API}/${id}/reset`).then((r) => r.data),
  retryFailed: (id) => axios.post(`${API}/${id}/retry-failed`).then((r) => r.data),
  confirmAudience: (id) => axios.post(`${API}/${id}/confirm-audience`).then((r) => r.data),
  unlockAudience: (id) => axios.delete(`${API}/${id}/confirm-audience`).then((r) => r.data),
  recipients: (id) => axios.get(`${API}/${id}/recipients`).then((r) => r.data),
  audiencePreview: (payload) => axios.post(`${API}/audience-preview`, payload).then((r) => r.data),
  search: (payload) => axios.post(`${API}/search-directory`, payload).then((r) => r.data),
  uploadUrl: (payload) => axios.post(`${API}/upload-url`, payload).then((r) => r.data),
};

export const emailLogsApi = {
  list: (exhibitionId, params = {}) => {
    const qs = new URLSearchParams({ exhibition_id: exhibitionId, ...params }).toString();
    return axios.get(`${LOGS_API}?${qs}`).then((r) => r.data);
  },
};

export const AUDIENCE_TYPES = [
  { value: 'tickets', label: 'Tickets' },
  { value: 'open_call', label: 'Open Call' },
  { value: 'artists', label: 'Artists' },
  { value: 'invite_prospects', label: 'Invite Prospects' },
  { value: 'custom', label: 'Custom Selection' },
];

export const TICKET_STATUS_OPTIONS = ['pending', 'accepted', 'declined', 'waitlist'];
export const OPEN_CALL_STATUS_OPTIONS = ['new', 'under_review', 'shortlisted', 'accepted', 'waitlist', 'declined', 'contacted'];
export const CURATOR_RATING_OPTIONS = ['average', 'good', 'very_good', 'genius'];
export const GLOBAL_RATING_OPTIONS = ['average', 'good', 'very_good', 'genius'];
export const ASSET_STATUS_OPTIONS = ['not_started', 'invited', 'in_progress', 'submitted', 'completed'];
export const RELATIONSHIP_STATUS_OPTIONS = ['interested', 'invited', 'confirmed', 'declined', 'showing'];

// Invite Prospect categories — derived from the live invite_search_results /
// invite_contacts data probed on Feb 13.
export const INVITE_CATEGORY_OPTIONS = [
  'artist',
  'curator',
  'gallery',
  'press',
  'institution',
  'museum',
  'collector',
  'art_advisor',
  'foundation',
  'academic',
  'tech_web3',
];
export const INVITE_PROSPECT_STATUS_OPTIONS = ['new', 'reviewed', 'saved'];

export const VARIABLE_TOKENS = [
  '{{name}}',
  '{{artist_name}}',
  '{{email}}',
  '{{ticket_status}}',
  '{{open_call_status}}',
  '{{curator_rating}}',
  '{{exhibition_title}}',
];

export const PERSONALIZATION_TOKENS = [
  { label: 'Name', token: '{{name}}', helper: 'Recipient first / display name' },
  { label: 'Artist Name', token: '{{artist_name}}', helper: 'Artist profile name when available' },
  { label: 'Email', token: '{{email}}', helper: 'Recipient email address' },
  { label: 'Ticket Status', token: '{{ticket_status}}', helper: 'Ticket decision · accepted / pending / etc.' },
  { label: 'Open Call Status', token: '{{open_call_status}}', helper: 'Open Call application status' },
  { label: 'Curator Rating', token: '{{curator_rating}}', helper: 'Curator rating · good / very_good / genius' },
  { label: 'Exhibition Title', token: '{{exhibition_title}}', helper: 'Current exhibition title' },
];

export const SOURCE_BADGE_STYLE = {
  ticket: { color: '#90E0EF', border: 'rgba(144,224,239,0.45)', bg: 'rgba(144,224,239,0.08)', label: 'TICKET' },
  open_call: { color: '#e4c07a', border: 'rgba(228,192,122,0.45)', bg: 'rgba(228,192,122,0.08)', label: 'OPEN CALL' },
  artist: { color: '#c89dff', border: 'rgba(200,157,255,0.45)', bg: 'rgba(200,157,255,0.08)', label: 'ARTIST' },
  invite_search_result: { color: '#7ed4a0', border: 'rgba(126,212,160,0.45)', bg: 'rgba(126,212,160,0.08)', label: 'INVITE · PROSPECT' },
  invite_contact: { color: '#7ed4a0', border: 'rgba(126,212,160,0.55)', bg: 'rgba(126,212,160,0.12)', label: 'INVITE · CONTACT' },
};
